import React, { useEffect, useRef, useState } from "react";
import CombinedMenu from "./CombinedMenu";
import styles from "./Header.module.scss";

const Header: React.FC = () => {
  const headerRef = useRef<HTMLDivElement>(null);
  const [headerHeight, setHeaderHeight] = useState(0);

  useEffect(() => {
    const headerElement = headerRef.current;
    if (!headerElement) {
      return;
    }

    const updateHeaderHeight = () => {
      setHeaderHeight(headerElement.getBoundingClientRect().height);
    };

    updateHeaderHeight();

    let resizeObserver: ResizeObserver | null = null;

    if (typeof ResizeObserver !== "undefined") {
      resizeObserver = new ResizeObserver(updateHeaderHeight);
      resizeObserver.observe(headerElement);
    }

    window.addEventListener("resize", updateHeaderHeight);

    return () => {
      if (resizeObserver) {
        resizeObserver.disconnect();
      }
      window.removeEventListener("resize", updateHeaderHeight);
    };
  }, []);

  return (
    <>
      <div
        aria-hidden="true"
        className={styles.headerSpacer}
        style={{ height: headerHeight }}
      />
      <div
        ref={headerRef}
        className={styles.header}
      >
        <CombinedMenu />
      </div>
    </>
  );
};

export default Header;
